import { render, staticRenderFns } from "./publishDetail.vue?vue&type=template&id=459b006b&scoped=true&"
import script from "./publishDetail.vue?vue&type=script&lang=js&"
export * from "./publishDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/mediaDetails/mediaDetails.less?vue&type=style&index=0&id=459b006b&lang=less&scoped=true&"
import style1 from "./publishDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459b006b",
  null
  
)

component.options.__file = "publishDetail.vue"
export default component.exports